// A `option` do grafico chega pronta do back, e a legenda vem sem `type`. Com
// muitas cidades selecionadas o ECharts quebra a legenda em varias linhas, que
// passam a competir em altura com o proprio grafico.
//
// `type: 'scroll'` e a forma nativa do ECharts de manter a legenda numa faixa
// de linha unica, com setas de paginacao indicando que ha mais itens. Mesmo
// padrao ja usado nos graficos do Flux Automatico (Daily/Monthly).
//
// Decisao registrada na #1879: nao limitar o numero de cidades -- o tratamento
// e na legenda, nao no que o cliente pode selecionar.

type AnyOption = Record<string, unknown>;

function asRecord(value: unknown): AnyOption | undefined {
  return value && typeof value === 'object' ? (value as AnyOption) : undefined;
}

function scrollify(legend: unknown): unknown {
  const record = asRecord(legend);
  if (!record) return legend;
  return { ...record, type: 'scroll' };
}

export default function withScrollableLegend(
  option: object | undefined,
): object | undefined {
  const opt = asRecord(option);
  // Sem legenda nao ha o que ajustar -- e o caso do heatmap, que usa visualMap.
  if (!opt || !('legend' in opt)) return option;

  const { legend } = opt;
  return {
    ...opt,
    legend: Array.isArray(legend) ? legend.map(scrollify) : scrollify(legend),
  };
}
